import useTrapFocus from 'Hooks/useTrapFocus';
import { IFacetGroupFilter } from 'Types/Litium';
import { useRef, useEffect } from 'react';
import FilterOption from 'Pages/ProductListingPage/FilterOption';

interface FacetGroupFilterProps
    extends Omit<IFacetGroupFilter, 'label' | 'id' | 'singleSelect'> {
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<number>>;
    filterId: string;
    toggleCheckbox: () => void;
    filterGroup: string;
    filterIsLoading: boolean;
    outsideRef: React.MutableRefObject<HTMLElement> | null;
    label: string;
}

const FacetGroupFilter = ({
    options,
    filterGroup,
    filterId,
    selectedOptions,
    showFilter,
    setShowFilter,
    toggleCheckbox,
    filterIsLoading,
    outsideRef,
    label,
}: FacetGroupFilterProps) => {
    const closeTrap = () => {
        setShowFilter(-1);
    };

    const myRef = useRef();
    const trapRef = useTrapFocus(showFilter, closeTrap);

    useEffect(() => {
        trapRef.current = myRef.current;
        if (outsideRef !== null) {
            if (showFilter) {
                outsideRef.current = myRef.current;
            }
        }
    }, [myRef.current, showFilter]);

    const hasColorValues = options?.some(item => item.colorHexCode);

    return (
        <fieldset
            className={`z-[3] transition-[visibility,_opacity] duration-layout  ${
                showFilter ? 'visible opacity-100' : 'invisible opacity-0'
            }`}
        >
            <legend className="sr-only">{label}</legend>
            <ul
                id={filterId}
                ref={myRef}
                className={`absolute left-0 top-full mt-[5px] flex gap-4 bg-white p-4.5 shadow-semiBold ${
                    hasColorValues
                        ? 'w-max max-w-[260px] flex-row flex-wrap'
                        : 'min-w-max flex-col '
                }`}
            >
                {options?.map((option, optionIndex) => (
                    <FilterOption
                        idPrefix="filter-group-option"
                        key={optionIndex}
                        filterIsLoading={filterIsLoading}
                        option={option}
                        selected={selectedOptions?.indexOf(option.id) >= 0}
                        filterGroup={filterGroup}
                        toggleCheckbox={toggleCheckbox}
                        capitalize={filterGroup === 'ProductMaterial'}
                    />
                ))}
            </ul>
        </fieldset>
    );
};

export default FacetGroupFilter;
